import template from './template.html';
import controller from './controller';


export default class ConfigEmailNotificationService {
    static get $inject() {
        return ['$http', '$uibModal', 'ApiService'];
    }

    constructor($http, $uibModal, ApiService) {
        this.$http = $http;
        this.$uibModal = $uibModal;
        this.ApiService = ApiService;
        this.modalInstace = null;
    }

    showModal(panelId, notifiedEmailItem) {
        this.panelId = angular.copy(panelId);
        this.notifiedEmailItem = angular.copy(notifiedEmailItem);
        this.modalInstace = this.$uibModal.open({
            template: template,
            controller: controller,
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
                notifiedEmailItem: () => {
                    return this.notifiedEmailItem;
                }, panelId: () => {
                    return this.panelId;
                },
            }
        });

        return this.modalInstace;
    }

    close() {
        if (this.modalInstace) {
            this.modalInstace.close();
        }
    }

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/configEmailNotification/service.js
 **/